import { render, staticRenderFns } from "./ResearchDirectory.vue?vue&type=template&id=46ef33e4"
import script from "./ResearchDirectory.vue?vue&type=script&lang=js"
export * from "./ResearchDirectory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ef33e4')) {
      api.createRecord('46ef33e4', component.options)
    } else {
      api.reload('46ef33e4', component.options)
    }
    module.hot.accept("./ResearchDirectory.vue?vue&type=template&id=46ef33e4", function () {
      api.rerender('46ef33e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/ResearchDirectory.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ResearchDirectory.vue
// module id = 406
// module chunks = 0